import { Injectable } from "@angular/core";
import { IDataSource } from "@calaosoft/osapp-common/store/models/IDataSource";
import { EDatabaseRole } from "@calaosoft/osapp-common/store/models/edatabase-role";
import { StringHelper } from "@calaosoft/osapp-common/utils/helpers/stringHelper";
import { Observable, of } from "rxjs";
import { Store } from "../../../../services/store.service";
import { IDashboard } from "../models/IDashboard";

@Injectable()
export class DashboardService {
	//#region METHODS

	constructor(private readonly isvcStore: Store) {}

	/** Récupère un dashboard dans la base de données, `undefined` si non trouvé.
	 * @param psId Identifiant du dashboard à récupérer.
	 * @param pbLive Indique si on récupère de façon continue le dashboard (lors de mise à jour par exemple), `false` par défaut.
	 */
	public getDashboard(psId?: string, pbLive: boolean = false): Observable<IDashboard | undefined> {
		if (StringHelper.isBlank(psId)) return of(undefined);

		const loDataSource: IDataSource = {
			databasesIds: this.isvcStore.getDatabasesIdsByRole(EDatabaseRole.workspace),
			viewParams: {
				key: psId,
				include_docs: true
			},
			live: pbLive
		} as IDataSource;

		return this.isvcStore.getOne<IDashboard>(loDataSource, false);
	}

	//#endregion
}
